import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'
import { getArtifactGroups, getEscalatedArtifacts } from '../../services/artifactService'
import useNotifications from '../useNotifications'

/**
 * Hook for fetching search results for escalated artifacts.
 * @returns {Object} object with state values for artifacts, totalArtifacts, and setRefetch,
 */
const useEscalatedArtifacts = () => {
  const MAX_RESULTS = 500
  const [t] = useTranslation()
  const { error } = useNotifications()
  const [artifacts, setArtifacts] = useState()
  const [totalArtifacts, setTotalArtifacts] = useState(0)
  const [refetch, setRefetch] = useState()

  useEffect(() => {
    let isCurrent = true
    getEscalatedArtifacts(MAX_RESULTS)
      .then(async (response) => {
        if (isCurrent) {
          setArtifacts(response.data.artifact)
          setTotalArtifacts(
            response.data.totalArtifactsSpanningPages === 1
              ? response.data.totalArtifactsSpanningPages + 1
              : response.data.totalArtifactsSpanningPages
          )
          const artifactsWithGroups = await Promise.allSettled(
            response.data.artifact.map(async (artifact) => {
              if (artifact.visibility === 'PRIVATE') {
                await getArtifactGroups(artifact.id)
                  .then((groupResponse) => {
                    artifact.groupIds = groupResponse.data.groupIds
                  })
                  .catch((err) => {
                    err.response?.status !== 403 &&
                      error(
                        t(
                          'artifacts.error.getArtifactGroups',
                          'Error getting artifact groups for artifact {artifactId}',
                          {
                            artifactId: artifact.id,
                          }
                        ),
                        err
                      )
                  })
              }
              return artifact
            })
          )
          setArtifacts(artifactsWithGroups.map((a) => a.value))
        }
      })
      .catch((err) => {
        if (isCurrent) {
          error(t('artifacts.error.errorGettingEscalatedArtifacs', 'Error getting escalated artifacts'), err)
          setArtifacts([])
          setTotalArtifacts(0)
        }
      })
    return () => {
      isCurrent = false
    }
  }, [error, refetch, t])

  return {
    artifacts,
    totalArtifacts,
    setRefetch,
  }
}

export default useEscalatedArtifacts
